export default function ProblemsSection() {
  const problems = [
    {
      icon: 'ri-search-line',
      title: 'HPがなくて検索で見つけてもらえない',
      description: '「地域名 + 業種」で検索しても出てこない。新規のお客さんとの接点がゼロの状態…'
    },
    {
      icon: 'ri-smartphone-line',
      title: 'HPが古くて、逆にイメージダウン',
      description: '何年も前のデザインのまま放置。スマホで見ると崩れて、信頼を失っているかも…'
    },
    {
      icon: 'ri-money-dollar-circle-line',
      title: '制作費が高すぎて、手が出せない',
      description: '見積もりを取ったら初期費用30万円以上。個人店舗にはとても払えない金額…'
    }
  ];

  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8 bg-white">
      <div className="max-w-6xl mx-auto">
        {/* Section Title */}
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-800 mb-4">
            こんなお悩みありませんか？
          </h2>
        </div>

        {/* Problems Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {problems.map((problem, index) => (
            <div 
              key={index}
              className="bg-slate-50 rounded-2xl p-8 border-2 border-slate-200 hover:border-cyan-600 transition-all duration-300 hover:shadow-xl"
            >
              <div className="w-16 h-16 flex items-center justify-center bg-cyan-600 rounded-full mb-6">
                <i className={`${problem.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-xl font-bold text-slate-800 mb-4">
                {problem.title}
              </h3>
              <p className="text-slate-600 leading-relaxed">
                {problem.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}